import { loginDestination } from "@/lib/adminNavigation";
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "@/components/AuthLayout";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/LanguageContext";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login({ email, password });
    setLoading(false);
    if (res.ok) {
      const to = loginDestination(res.user, location.state?.from);
      navigate(to, { replace: true });
    } else if (res.pending_deletion) {
      navigate("/account/recovery", {
        replace: true,
        state: { email, scheduled_at: res.scheduled_at },
      });
    } else {
      setError(res.error === "account_suspended" ? t("accountSuspended") : res.error);
    }
  };

  return (
    <AuthLayout title={t("auth.login.title")} subtitle={t("auth.login.subtitle")} testId="login-page">
      <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
        <div>
          <label htmlFor="login-email-input" className="text-xs uppercase tracking-widest" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
            {t("common.email")}
          </label>
          <input id="login-email-input"
            type="email"
            required
            className="nvl-input mt-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            autoComplete="email"
          />
        </div>
        <div>
          <label htmlFor="login-password-input" className="text-xs uppercase tracking-widest" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
            {t("common.password")}
          </label>
          <input id="login-password-input"
            type="password"
            required
            className="nvl-input mt-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            autoComplete="current-password"
          />
        </div>

        {error ? (
          <div className="text-sm" style={{ color: "hsl(var(--destructive))" }} data-testid="login-error">
            {error}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={loading}
          className="nvl-btn nvl-btn-primary w-full disabled:opacity-60"
          data-testid="login-submit-button"
        >
          {loading ? t("common.loading") : t("auth.login.submit")}
        </button>

        <div className="flex items-center justify-between text-sm">
          <Link to="/forgot-password" data-testid="login-forgot-link" className="underline">
            {t("auth.login.forgot")}
          </Link>
          <span style={{ color: "hsl(var(--nvl-ink-soft))" }}>
            {t("auth.login.noAccount")}{" "}
            <Link to="/register" data-testid="login-register-link" className="font-medium underline">
              {t("auth.login.register")}
            </Link>
          </span>
        </div>
      </form>
    </AuthLayout>
  );
}
